// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-0cdfd38c] .menuDetailDrawer .el-drawer__header {\n  padding: 1.25rem;\n  margin: 0;\n  border-bottom: 0.0625rem solid #e3e3e3;\n  color: #666;\n}\n[data-v-0cdfd38c] .menuDetailDrawer .el-drawer__body {\n  padding: 1.25rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
